import { HLS_KR, HLS, SS } from '../../utils/playerConstants';
import deviceInfo from '../all/deviceInfo';

const multipleaudio = {};
// HLS_KR
multipleaudio.hls_kr = {};
multipleaudio.hls_kr.vod = false;
multipleaudio.hls_kr.live = false;
multipleaudio.hls_kr.timeshift = false;
// HLS
multipleaudio.hls = {};
multipleaudio.hls.vod = false;
multipleaudio.hls.live = false;
multipleaudio.hls.timeshift = false;
// SS
multipleaudio.smooth_streaming = {};
multipleaudio.smooth_streaming.vod = true;
multipleaudio.smooth_streaming.live = false;
multipleaudio.smooth_streaming.timeshift = false;

// Put only SINGLE streams here
const supported_stream_types = {};
// in priority order, first has a major priority
supported_stream_types.vod = [SS, HLS];
supported_stream_types.live = [HLS_KR, HLS];
supported_stream_types.timeshift = [HLS_KR, HLS];

export default {
  appKey: '04886f601ba31998511018b18dfc8ea3',
  appSubkey: 'zeasn',
  // Request params
  device_category: 'tv',
  /* device_id:"nousar", */
  device_manufacturer: 'zeasn',
  device_model: 'zeasn',
  device_name: 'zeasn',
  device_so: deviceInfo.os.description || 'opera',
  device_type: 'tv',
  stream_type: 'smooth_streaming',
  akamai_id: 'mfwkzeasn-api.clarovideo.net',
  useEpgPostals: true,
  // akamai_mfwk: 'mfwktv2sony-api.clarovideo.net'
  akamai_mfwk: (window.location && window.location.protocol) ? window.location.protocol + '//' + 'mfwktv-api.clarovideo.net' : 'http://mfwktv-api.clarovideo.net'
};



// WEBPACK FOOTER //
// ./src/devices/zeasn/config.js